import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconVolumeMuteOutline } from '@saucelabs/ds-icons';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import * as globalSelectors from '../../../selectors';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const AudioButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const {
    device,
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const { isWebRtcAudioEnabled } = useSelector(globalSelectors.mobileSessionSelector);

  const toggleAudio = () => {
    device?.toggleAudio();

    trackEvent(TOOLBAR_TRACKING_NAMES.AUDIO, { deviceType, testType });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconVolumeMuteOutline}
      label="Audio"
      onPress={toggleAudio}
      role={role}
      status={isWebRtcAudioEnabled}
    />
  );
};

AudioButton.displayName = 'AudioButton';

export default AudioButton;
